<template>
  <div>
    <div class="logo-wrapper">

      <div style="height: 48px;padding-top: 10px;">
        <router-link to="/projects/list">

                    <img
                        style="height:  32px;"
                        class="img-fluid"
                        src="../../assets/images/logo/logo.png"
                        alt=""
/>
        </router-link>
      </div>

<!--      <Logo/>-->
      <div class="back-btn" @click="toggle_sidebar">
        <i class="fa fa-angle-left"></i>
      </div>
      <div class="toggle-sidebar" @click="toggle_sidebar">
        <feather
            class="status_toggle middle"
            type="grid"
            id="sidebar-toggle"
        ></feather>
      </div>
    </div>
    <div class="logo-icon-wrapper" style="padding: 18px 22px;margin-bottom: 20px;">
      <div style="height: 48px">
        <router-link to="/projects/list" style="position: absolute;left: 30px;top: 27px;">
          <svg style="width: 30px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </router-link>
      </div>

      <!--      <router-link to="/projects/list">-->
<!--        <img-->
<!--            style="height:  48px;opacity: 0"-->
<!--            class="img-fluid"-->
<!--            src="../../assets/images/logo/logo_purple_small.png"-->
<!--            alt=""-->
<!--        /></router-link>-->
    </div>
    <Nav/>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import Nav from './nav.vue';

export default {
  name: 'Sidebar',
  components: {
    Nav,
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
    }),
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch('menu/opensidebar');
      this.$store.state.menu.activeoverlay = false;
    },
  },
};
</script>
